import React from 'react'
import Helmet from 'react-helmet'

const SaleTransactionPending = ({ txn }) => (
  <div className='pending'>
    <Helmet>
      <title>Transaction pending: Merchant Demonstrator</title>
    </Helmet>
    <h1>Waiting for upstream PSP...</h1>
  </div>
)

export default SaleTransactionPending
